module.exports = __webpack_public_path__ + "DINNextLTPro-BlackItalic.woff?ff59f7333780d1a4054f4cf97f32f12a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-BlackItalic.woff
// module id = 1446
// module chunks = 0